import React from 'react';
import { TextStyle } from '@superops/ui-design-system';
import { injectIntl } from 'react-intl';
import { isEmpty } from 'lodash';

import Tippy from '@tippyjs/react';

function AutoInfoTextCell(props) {
  const { cell, intl } = props;

  return (
    <Tippy
      content={
        <div className="p12 scroll wm-600 mh-400  border-radius-inherit line-break-anywhere">
          <TextStyle>{cell?.value}</TextStyle>
        </div>
      }
      duration={250}
      delay={500}
      interactive
      placement="bottom-start"
      arrow={false}
      allowHTML
      theme="light"
      appendTo={document.body}
      disabled={isEmpty(cell?.value)}
    >
      <div className="twoLineBreakText">{cell?.value ? cell?.value : 'NA'}</div>
    </Tippy>
  );
}

export default injectIntl(AutoInfoTextCell);
